"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = void 0;
const _1 = require(".");
const error_handler_1 = require("../error-handler");
const query = async (query, { variables }) => {
    const result = await _1.client.query({
        query,
        variables,
    });
    if (result.errors) {
        console.log('API request returned some errors:');
        console.log(JSON.stringify({ errors: result.errors, variables, mutation: query }, null, 2));
    }
    return {
        data: result.data,
        errors: (0, error_handler_1.reduceErrors)(result.errors),
    };
};
exports.query = query;
